/* eslint-disable max-len */ import { ArrayUtils } from '../../../../../shared/utils/ArrayUtils.ts';
import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventValue, AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { ViewPopupLogin } from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { navigateToPage, sendToAppropriateMobileStore } from '../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { UIPrivateAdController } from '../../ui_ad/UIPrivateAdController.ts';
import { setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { BotsMatchType, MatchmakingMatchTypes } from '@colonist/game-base-types';
import { uiManager } from '../../EntryHomepage.ts';
import { userHasAccessToRankedCitiesAndKnights } from '../../../../../shared/matchmaking/MatchmakingUtils.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { HolidayDateUtils, holidayKey } from '../../../../shared/scripts/HolidayDateUtils.ts';
import LobbyAdSignIn from '@static/images/lobby_ad_signin.svg';
import LobbyAdPlus from '@static/images/lobby_ad_plus.png';
import LobbyAdPremium from '@static/images/lobby_ad_premium.png';
import LobbyAdRanked from '@static/images/lobby_ad_ranked.png';
import LobbyAdCkRanked from '@static/images/lobby_ad_ck_ranked.png';
import LobbyAdMobileApp from '@static/images/lobby_ad_mobile_app.png';
import LobbyAdDiscordLogin from '@static/images/lobby_ad_discordlogin.svg';
import StoreColorBlack from '@static/images/store_color_black.png';
import IconGameMode1V1 from '@static/images/icon_gamemode_1v1.svg';
import IconGift from '@static/images/icon_gift.png';
import IconRewardsProgram from '@static/images/icon_rewards_program.png';
import GameModeCitiesAndKnights from '@static/images/game_mode_icons/cities_and_knights.svg';
import IconTie from '@static/images/icon_tie.svg';
import IconGiftBox from '@static/images/icon_gift_box.svg';
import LobbyAdValentines from '@static/images/lobby_ad_valentines.png';
import LobbyAdEaster from '@static/images/lobby_ad_easter.png';
import LobbyAdHalloween from '@static/images/lobby_ad_halloween.png';
import LobbyAdThanksgiving from '@static/images/lobby_ad_thanksgiving.png';
import LobbyAdChristmas from '@static/images/lobby_ad_christmas.png';
import LobbyAdRush10Min from '@static/images/lobby_ad_rush_10_min.svg';
import LobbyAdRush4Player10Min from '@static/images/lobby_ad_rush_4_player_10_min.svg';
import LobbyAdRush4Player from '@static/images/lobby_ad_rush_4_player.svg';
import LobbyAdRushBot from '@static/images/lobby_ad_rush_bot.svg';
import { AudioManager, AudioType } from '@colonist/audio';
import { sendRushAdClicked, sendRushAdImpression } from '../../../../shared/scripts/analytics/sendRushAdAnalytic.ts';
import { uiManagerEvents } from '../../../../shared/scripts/EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
const adTranslationKey = [
    'discordLogin',
    'mobile',
    'citiesAndKnightsRanked',
    'ranked',
    'membership.premium',
    'membership.plus',
    'signIn',
    'membership.elite',
    'freeColor',
    'playCitiesAndKnights',
    'play1v1',
    'gifting',
    'joinTeam',
    'rewardsProgram',
    'rush10Min',
    'rushFavorite',
    'rush4Player10Min',
    'rushNoTurns',
    'rushNoTurnsBuild',
    ...holidayKey
];
export class UIHomepageAdView {
    hide() {
        if (this.container == undefined) return;
        this.container.style.display = 'none';
    }
    show() {
        if (this.container == undefined) return;
        this.container.style.display = 'flex';
    }
    update() {
        void this.showDefaultAd();
    }
    clickAction(event, adToShow) {
        var _ClientUserState_userState;
        event.preventDefault();
        AudioManager.play(AudioType.Click);
        const eventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: this.isHolidayAdBeingShown ? AnalyticEventCategory.GiftMembershipOverlay : AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: adToShow.clickAnalytic
        };
        void CA.sendAnalyticEvent(eventData);
        if (adToShow.rushVariant != undefined) sendRushAdClicked('homepage', adToShow.rushVariant);
        if (adToShow.isLoggedInRequired && !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) {
            new ViewPopupLogin();
            return;
        }
        if (typeof adToShow.buttonUrl == 'string') {
            const shouldOpenSubscriptionOverlay = adToShow.buttonUrl == '/store#membership' && isSubscriptionOverlayVariant();
            if (shouldOpenSubscriptionOverlay) uiManagerEvents.premiumMembershipCheckAction();
            else navigateToPage(adToShow.buttonUrl, true);
            return;
        }
        if (adToShow.buttonAction != undefined) adToShow.buttonAction();
    }
    async showDefaultAd() {
        const adToShow = await this.getAdToShow();
        this.image.src = adToShow.image;
        if (adToShow.rushVariant != undefined) sendRushAdImpression('homepage', adToShow.rushVariant);
        if (this.button.parentElement != undefined) setElementOnClick(this.button.parentElement, (event)=>this.clickAction(event, adToShow));
        setElementInnerHTML(this.title, adToShow.title);
        if (this.description != undefined) setElementInnerHTML(this.description, adToShow.description);
        setElementInnerHTML(this.button, adToShow.buttonName);
        if (adToShow.buttonIcon) {
            // eslint-disable-next-line no-restricted-syntax
            this.button.innerHTML = `<img src="${adToShow.buttonIcon}">   ${this.button.innerHTML}`;
        }
    }
    async getAdToShow() {
        if (this.shouldShowHolidayAd()) return this.getHolidayAd();
        const newAdList = [];
        this.ads = UIPrivateAdController.filterAds(this.ads);
        for (const ad of this.ads){
            for(let i = 0; i < ad.exposure; i++){
                newAdList.push(ad);
            }
        }
        return ArrayUtils.randomElementFromArray(newAdList);
    }
    static getStringAdData(key) {
        return {
            title: {
                key: `strings:homePage.colonistAds.${key}.title`
            },
            description: {
                key: `strings:homePage.colonistAds.${key}.description`
            },
            buttonName: {
                key: `strings:homePage.colonistAds.${key}.buttonName`
            }
        };
    }
    static onClickPlayCK() {
        var _ClientUserState_userState, _ClientUserState_userState1, _ClientUserState_userState2, _ClientUserState_userState3;
        if (!userHasAccessToRankedCitiesAndKnights((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items, (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.ckTotalGameCount, ClientUserState.abTests, (_ClientUserState_userState2 = ClientUserState.userState) === null || _ClientUserState_userState2 === void 0 ? void 0 : _ClientUserState_userState2.ckNextRerollAt, (_ClientUserState_userState3 = ClientUserState.userState) === null || _ClientUserState_userState3 === void 0 ? void 0 : _ClientUserState_userState3.ckFreeGameUntil)) {
            if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
            else navigateToPage('/store#membership', true);
            return;
        }
        uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedCitiesAndKnights4P);
    }
    static onClickPlayRushBots() {
        void uiManager.goToMainPageAndSelectMatchType(BotsMatchType.ColonistRush);
    }
    setHolidayAdKey() {
        this.holidayAdKey = HolidayDateUtils.getCurrentHoliday();
    }
    getHolidayAd() {
        switch(this.holidayAdKey){
            case 'valentines':
                return {
                    ...UIHomepageAdView.getStringAdData('valentines'),
                    image: LobbyAdValentines,
                    buttonUrl: '/store#gift',
                    exposure: 1,
                    clickAnalytic: GiftMembershipMethod.LobbyAd,
                    buttonIcon: IconGiftBox,
                    isLoggedInRequired: true
                };
            case 'easter':
                return {
                    ...UIHomepageAdView.getStringAdData('easter'),
                    image: LobbyAdEaster,
                    buttonUrl: '/store#gift',
                    exposure: 1,
                    clickAnalytic: GiftMembershipMethod.LobbyAd,
                    buttonIcon: IconGiftBox,
                    isLoggedInRequired: true
                };
            // case 'mothersday': return {...UIHomepageAdView.getStringAdData('mothersday'), image: LobbyAdMothersDay, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            // case 'fathersday': return {...UIHomepageAdView.getStringAdData('fathersday'), image: LobbyAdFathersDay, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            case 'halloween':
                return {
                    ...UIHomepageAdView.getStringAdData('halloween'),
                    image: LobbyAdHalloween,
                    buttonUrl: '/store#gift',
                    exposure: 1,
                    clickAnalytic: GiftMembershipMethod.LobbyAd,
                    buttonIcon: IconGiftBox,
                    isLoggedInRequired: true
                };
            case 'thanksgiving':
                return {
                    ...UIHomepageAdView.getStringAdData('thanksgiving'),
                    image: LobbyAdThanksgiving,
                    buttonUrl: '/store#gift',
                    exposure: 1,
                    clickAnalytic: GiftMembershipMethod.LobbyAd,
                    buttonIcon: IconGiftBox,
                    isLoggedInRequired: true
                };
            case 'christmas':
                return {
                    ...UIHomepageAdView.getStringAdData('christmas'),
                    image: LobbyAdChristmas,
                    buttonUrl: '/store#gift',
                    exposure: 1,
                    clickAnalytic: GiftMembershipMethod.LobbyAd,
                    buttonIcon: IconGiftBox,
                    isLoggedInRequired: true
                };
            default:
                throw new Error('holiday ad called without a valid holiday ad key');
        }
    }
    setHolidayAdClasses() {
        var _this_image_classList, _adContentContainer_classList, _this_button_classList;
        (_this_image_classList = this.image.classList) === null || _this_image_classList === void 0 ? void 0 : _this_image_classList.toggle('homepage-left-holiday-ad', this.isHolidayAdBeingShown);
        const adContentContainer = this.container.children[0];
        if (adContentContainer == undefined) throw new Error('Wrong HTML structure in homepage-left.ejs');
        (_adContentContainer_classList = adContentContainer.classList) === null || _adContentContainer_classList === void 0 ? void 0 : _adContentContainer_classList.toggle('homepage-holiday-ad-content', this.isHolidayAdBeingShown);
        (_this_button_classList = this.button.classList) === null || _this_button_classList === void 0 ? void 0 : _this_button_classList.toggle('homepage-holiday-ad-button', this.isHolidayAdBeingShown);
    }
    shouldShowHolidayAd() {
        if (this.holidayAdKey == undefined) return false;
        const holidayAdsProbability = 0.5;
        this.isHolidayAdBeingShown = Math.random() < holidayAdsProbability;
        this.setHolidayAdClasses();
        return this.isHolidayAdBeingShown;
    }
    constructor(){
        this.ads = [
            {
                ...UIHomepageAdView.getStringAdData('signIn'),
                image: LobbyAdSignIn,
                buttonAction: ()=>new ViewPopupLogin(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdViewSignIn,
                filterIfLoggedIn: true,
                filterIfDiscord: true
            },
            {
                ...UIHomepageAdView.getStringAdData('membership.plus'),
                image: LobbyAdPlus,
                buttonUrl: '/store#membership',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdViewMemberships,
                filterIfMembership: true
            },
            {
                ...UIHomepageAdView.getStringAdData('membership.premium'),
                image: LobbyAdPremium,
                buttonUrl: '/store#membership',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdViewMemberships,
                filterIfMembership: true
            },
            {
                ...UIHomepageAdView.getStringAdData('ranked'),
                image: LobbyAdRanked,
                buttonUrl: '/leaderboards',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdViewLeaderboards
            },
            {
                ...UIHomepageAdView.getStringAdData('citiesAndKnightsRanked'),
                image: LobbyAdCkRanked,
                buttonUrl: '/leaderboards/CitiesAndKnights4P',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdViewLeaderboards
            },
            {
                ...UIHomepageAdView.getStringAdData('mobile'),
                image: LobbyAdMobileApp,
                buttonAction: ()=>sendToAppropriateMobileStore(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdDownloadMobile
            },
            {
                ...UIHomepageAdView.getStringAdData('discordLogin'),
                image: LobbyAdDiscordLogin,
                buttonAction: ()=>UIPrivateAdController.accountLinkingAction(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdDiscordLogin,
                filterIfDiscord: true
            },
            {
                ...UIHomepageAdView.getStringAdData('joinTeam'),
                image: IconTie,
                buttonUrl: '/careers',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdHire
            },
            {
                ...UIHomepageAdView.getStringAdData('freeColor'),
                image: StoreColorBlack,
                buttonUrl: '/store#colors',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdFreeColor
            },
            {
                ...UIHomepageAdView.getStringAdData('playCitiesAndKnights'),
                image: GameModeCitiesAndKnights,
                buttonAction: ()=>UIHomepageAdView.onClickPlayCK(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayCitiesAndKnights
            },
            {
                ...UIHomepageAdView.getStringAdData('play1v1'),
                image: IconGameMode1V1,
                buttonAction: ()=>uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.UnrankedClassic1v1),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlay1v1
            },
            {
                ...UIHomepageAdView.getStringAdData('gifting'),
                image: IconGift,
                buttonUrl: '/store#gift',
                exposure: 1,
                clickAnalytic: GiftMembershipMethod.LobbyAd,
                isLoggedInRequired: true
            },
            {
                ...UIHomepageAdView.getStringAdData('rewardsProgram'),
                image: IconRewardsProgram,
                buttonUrl: '/store#referrals',
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdRewardsProgram
            },
            {
                ...UIHomepageAdView.getStringAdData('rush10Min'),
                image: LobbyAdRush10Min,
                buttonAction: ()=>UIHomepageAdView.onClickPlayRushBots(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayColonistRush,
                rushVariant: 'rush10Min'
            },
            {
                ...UIHomepageAdView.getStringAdData('rushFavorite'),
                image: LobbyAdRushBot,
                buttonAction: ()=>UIHomepageAdView.onClickPlayRushBots(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayColonistRush,
                rushVariant: 'rushFavorite'
            },
            {
                ...UIHomepageAdView.getStringAdData('rush4Player10Min'),
                image: LobbyAdRush4Player10Min,
                buttonAction: ()=>UIHomepageAdView.onClickPlayRushBots(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayColonistRush,
                rushVariant: 'rush4Player10Min'
            },
            {
                ...UIHomepageAdView.getStringAdData('rushNoTurns'),
                image: LobbyAdRush4Player10Min,
                buttonAction: ()=>UIHomepageAdView.onClickPlayRushBots(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayColonistRush,
                rushVariant: 'rushNoTurns'
            },
            {
                ...UIHomepageAdView.getStringAdData('rushNoTurnsBuild'),
                image: LobbyAdRush4Player,
                buttonAction: ()=>UIHomepageAdView.onClickPlayRushBots(),
                exposure: 1,
                clickAnalytic: AnalyticEventValue.LobbyAdPlayColonistRush,
                rushVariant: 'rushNoTurnsBuild'
            }
        ];
        this.isHolidayAdBeingShown = false;
        this.container = document.getElementById(`scene_homepage_ad_container`);
        this.image = document.getElementById(`scene_homepage_store_ad_image`);
        this.title = document.getElementById(`scene_homepage_store_ad_title`);
        this.description = document.getElementById('scene_homepage_store_ad_description');
        this.button = document.getElementById(`scene_homepage_store_ad_button`);
        this.setHolidayAdKey();
    }
}
